// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".history-view{padding-top:2.8125rem;padding-bottom:3.125rem;font-family:Arial,Helvetica,\"sans-serif\"}", ""]);
// Exports
module.exports = exports;
